/* eslint-disable vue/sort-keys */
import {
  Layout,
  ResponsiveLayout,
} from '@robovision/rvai-base'
import { RouteNames } from '../moduleRouteNames/monitoring'
import type { RvaiRouteRecord } from '../types'


// We need to ignore "imports" for components properties in routes,
// because without it we have no possibility to import (dynamically) pages for specific router.
// Normally we don't need to import something from "pages" into router,
// but eslint doesn't know the difference between normal and dynamic imports.
export const routes: RvaiRouteRecord<RouteNames> = {
  path: '/monitoring',
  component: ResponsiveLayout,

  meta: {
    can: ['read', 'Inference'],
  },

  children: [
    {
    // eslint-disable-next-line import/no-restricted-paths
      component: () => import('~modules/monitoring/pages/Monitoring.vue'),
      path: '',

      children: [
        {
          path: '',
          name: RouteNames.Monitoring,
          redirect: { name: RouteNames.InferenceMonitoring },
        },
        {
          // eslint-disable-next-line import/no-restricted-paths
          component: () => import('~modules/monitoring/components/InferenceMonitoringContent.vue'),
          meta: {
            allowedLayouts: [Layout.LeftOnly],
          },
          name: RouteNames.InferenceMonitoring,
          path: 'inference',
        },
      ],
    },
  ],
}
